import { render, staticRenderFns } from "./KnowledgeBaseAdd.vue?vue&type=template&id=7dd5b38e&"
import script from "./KnowledgeBaseAdd.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports